import { createContext } from "react";

export const AccordionItemContext = createContext({
  isExpanded: false,
  id: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggle: () => {},
});
export const AccordionItemProvider = AccordionItemContext.Provider;
export const AccordionItemConsumer = AccordionItemContext.Consumer;
